import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

export interface UserApiKeyState {
  hasKey: boolean;
  apiKey: string | null;
  generatedAt: number | null;
}

/** Get the API key state of a target user (staff only). */
export async function getUserApiKey(userUid: string, auth: Authentication): Promise<UserApiKeyState> {
  try {
    const response = await HttpClient.get(`/admin/users/${userUid}/api-key`, auth.token);
    return {
      hasKey: Boolean(response.data.has_key),
      apiKey: response.data.api_key ?? null,
      generatedAt: response.data.generated_at ?? null,
    };
  } catch (error) {
    throw new ManageUserApiKeyFailure();
  }
}

/** Generate an API key for a target user (staff only). Returns the new key (shown once). */
export async function generateUserApiKey(userUid: string, auth: Authentication): Promise<string> {
  try {
    const response = await HttpClient.post(`/admin/users/${userUid}/api-key`, {}, auth.token);
    return response.data.api_key as string;
  } catch (error) {
    throw new ManageUserApiKeyFailure();
  }
}

/** Revoke the API key of a target user (staff only). */
export async function revokeUserApiKey(userUid: string, auth: Authentication): Promise<void> {
  try {
    await HttpClient.delete(`/admin/users/${userUid}/api-key`, {}, auth.token);
  } catch (error) {
    throw new ManageUserApiKeyFailure();
  }
}

export class ManageUserApiKeyFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
